<script>
  import { cn } from '@lib/utils'

  let { src, text = "", class: className, ...restProps } = $props()

</script>

{#if src}
  <img {src} class={cn('rounded-md object-cover', className)} style="image-rendering: high-quality;" {...restProps} />
{:else}
  <div class={cn('flex justify-center items-center text-gray-500', className)} {...restProps}>
    {text}
  </div>
{/if}
